export default {
  name: 'Fuel',

  computed: {
    fuelCreateConfig () {
      return {
        title: this.$t('fleet/vehicle.fuel'),
        key: 'fuel',
        validationErrors: this.validationErrors,
        tabContent: [
          {
            title: this.$t('fleet/vehicle.fuel'),
            component: this.columnsContentComponent,
            rows: [
              {
                columnsCount: 4,
                fields: [
                  {
                    key: 'fuel_type_id',
                    label: this.$t('fleet/vehicle.fuel_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicles/fuel-types'
                    },
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'fuel_tank_capacity',
                    label: this.$t('fleet/vehicle.fuel_tank_capacity'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'idle_fuel_consumption',
                    label: this.$t('fleet/vehicle.idle_fuel_consumption'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'urban_fuel_consumption',
                    label: this.$t('fleet/vehicle.urban_fuel_consumption'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'open_road_fuel_consumption',
                    label: this.$t('fleet/vehicle.open_road_fuel_consumption'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  },
                  {
                    key: 'combined_fuel_consumption',
                    label: this.$t('fleet/vehicle.combined_fuel_consumption'),
                    field_type: 'number',
                    visible: true,
                    editable: true,
                    creatable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
